import React, { useEffect, useState } from "react";
import { toast } from "sonner";
import { api } from "../../lib/api";
import { downloadCsv } from "../../components/AdminLayout";

const ARTWORK_STATUSES = ["ARTWORK NEEDED", "ARTWORK RECEIVED", "MOCKUP NEEDED", "MOCKUP CREATED", "REVISION NEEDED", "READY FOR PRODUCTION"];

export default function AdminProduction() {
  const [rounds, setRounds] = useState([]);
  const [roundId, setRoundId] = useState("");
  const [mpo, setMpo] = useState(null);
  const [moq, setMoq] = useState([]);
  const [artwork, setArtwork] = useState([]);
  const [tab, setTab] = useState("mpo");

  useEffect(() => {
    api.get("/rounds").then(({ data }) => {
      setRounds(data);
      const open = data.find((r) => r.status === "OPEN") || data[0];
      if (open) setRoundId(open.id);
    });
    api.get("/admin/artwork").then(({ data }) => setArtwork(data)).catch(() => {});
  }, []);

  useEffect(() => {
    if (!roundId) return;
    api.get(`/admin/production/${roundId}`).then(({ data }) => setMpo(data)).catch(() => {});
    api.get(`/admin/moq/${roundId}`).then(({ data }) => setMoq(data)).catch(() => {});
  }, [roundId]);

  const setArtStatus = async (id, status) => {
    try { await api.patch(`/admin/artwork/${id}/status`, { status }); toast.success("Updated"); api.get("/admin/artwork").then(({ data }) => setArtwork(data)); }
    catch { toast.error("Failed"); }
  };

  return (
    <div className="px-5 lg:px-8 py-8">
      <div className="flex flex-wrap items-center justify-between gap-4 mb-6">
        <div>
          <p className="font-mono text-yellow-400 uppercase tracking-widest text-xs">Production & Fulfillment</p>
          <h1 className="font-heading font-black uppercase text-4xl text-white mt-1">Master Production</h1>
        </div>
        <select data-testid="production-round" value={roundId} onChange={(e) => setRoundId(e.target.value)} className="bg-[#121216] border border-white/15 rounded px-3 py-2 text-sm text-white">
          {rounds.map((r) => <option key={r.id} value={r.id}>{r.name} · {r.status}</option>)}
        </select>
      </div>

      <div className="flex gap-2 mb-5">
        {[["mpo", "Master Production Order"], ["moq", "MOQ Tracking"], ["artwork", "Artwork"]].map(([k, l]) => (
          <button key={k} data-testid={`prod-tab-${k}`} onClick={() => setTab(k)} className={`px-4 py-2 rounded-sm text-sm font-mono uppercase ${tab === k ? "bg-yellow-400 text-black" : "bg-[#121216] text-zinc-400 border border-white/10"}`}>{l}</button>
        ))}
      </div>

      {tab === "mpo" && mpo && (
        <div>
          <div className="flex items-center justify-between mb-3">
            <p className="font-mono text-sm text-zinc-400">{mpo.line_count} lines · <span className="text-white font-bold">{mpo.total_units} total units</span> · Retail + Wholesale consolidated</p>
            <button onClick={() => downloadCsv(api, `/admin/export/production?round=${roundId}`, "paragon_production.csv")} className="btn-outline px-4 py-2 rounded-sm text-sm">Export CSV</button>
          </div>
          <div className="bg-[#121216] border border-white/10 rounded-lg overflow-x-auto">
            <table className="w-full text-sm">
              <thead><tr className="text-left font-mono text-[10px] uppercase tracking-widest text-zinc-500 border-b border-white/10">
                <th className="px-4 py-3">Product</th><th className="px-4 py-3">Audience</th><th className="px-4 py-3">Color</th><th className="px-4 py-3">Personalization</th><th className="px-4 py-3">Size</th><th className="px-4 py-3">Academy</th><th className="px-4 py-3">Channel</th><th className="px-4 py-3">Qty</th>
              </tr></thead>
              <tbody>
                {mpo.rows.map((r, i) => (
                  <tr key={i} className="border-b border-white/5">
                    <td className="px-4 py-2.5 text-white">{r.product_name}</td>
                    <td className="px-4 py-2.5 text-zinc-400">{r.audience}</td>
                    <td className="px-4 py-2.5 text-zinc-400">{r.color}</td>
                    <td data-testid={`production-personalization-${i}`} className="px-4 py-2.5 text-yellow-400 font-mono text-xs">{r.personalization || "-"}</td>
                    <td className="px-4 py-2.5 font-mono text-white">{r.size}</td>
                    <td className="px-4 py-2.5 text-emerald-400">{r.academy}</td>
                    <td className="px-4 py-2.5 text-zinc-400">{r.channel}</td>
                    <td className="px-4 py-2.5 font-mono font-bold text-yellow-400">{r.qty}</td>
                  </tr>
                ))}
              </tbody>
            </table>
            {mpo.rows.length === 0 && <p className="text-zinc-600 font-mono text-sm p-8 text-center">No orders to consolidate for this round yet.</p>}
          </div>
        </div>
      )}

      {tab === "moq" && (
        <div className="bg-[#121216] border border-white/10 rounded-lg overflow-x-auto">
          <table className="w-full text-sm">
            <thead><tr className="text-left font-mono text-[10px] uppercase tracking-widest text-zinc-500 border-b border-white/10">
              <th className="px-4 py-3">Product</th><th className="px-4 py-3">Paid Qty</th><th className="px-4 py-3">MOQ</th><th className="px-4 py-3">Status</th>
            </tr></thead>
            <tbody>
              {moq.map((m) => (
                <tr key={m.product_id} className="border-b border-white/5">
                  <td className="px-4 py-2.5 text-white">{m.product_name}</td>
                  <td className="px-4 py-2.5 font-mono">{m.paid_qty}</td>
                  <td className="px-4 py-2.5 font-mono">{m.moq}</td>
                  <td className="px-4 py-2.5 font-mono">{m.reached ? <span className="text-emerald-400">REACHED</span> : <span className="text-yellow-400">NOT REACHED {m.paid_qty}/{m.moq}</span>}</td>
                </tr>
              ))}
            </tbody>
          </table>
          {moq.length === 0 && <p className="text-zinc-600 font-mono text-sm p-8 text-center">No paid units yet.</p>}
        </div>
      )}

      {tab === "artwork" && (
        <div className="bg-[#121216] border border-white/10 rounded-lg overflow-x-auto">
          <table className="w-full text-sm">
            <thead><tr className="text-left font-mono text-[10px] uppercase tracking-widest text-zinc-500 border-b border-white/10">
              <th className="px-4 py-3">Artwork</th><th className="px-4 py-3">Academy</th><th className="px-4 py-3">Version</th><th className="px-4 py-3">Status</th>
            </tr></thead>
            <tbody>
              {artwork.map((a) => (
                <tr key={a.id} className="border-b border-white/5">
                  <td className="px-4 py-2.5 text-white">{a.name}</td>
                  <td className="px-4 py-2.5 text-zinc-400">{a.academy_id}</td>
                  <td className="px-4 py-2.5 font-mono">v{a.version}</td>
                  <td className="px-4 py-2.5">
                    <select value={a.status} onChange={(e) => setArtStatus(a.id, e.target.value)} className="bg-[#0A0A0C] border border-white/15 rounded px-2 py-1.5 text-xs text-white">
                      {ARTWORK_STATUSES.map((s) => <option key={s} value={s}>{s}</option>)}
                    </select>
                  </td>
                </tr>
              ))}
            </tbody>
          </table>
          {artwork.length === 0 && <p className="text-zinc-600 font-mono text-sm p-8 text-center">No artwork submitted yet.</p>}
        </div>
      )}
    </div>
  );
}
